/**
 * Copy discount code to clipboard; swap icon to checkmark briefly.
 */
(function () {
  const RESET_MS = 2000;

  async function copyText(text) {
    if (!text) return false;

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        // fall through to legacy copy
      }
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (error) {
      ok = false;
    }
    document.body.removeChild(textarea);
    return ok;
  }

  function setCopiedState(button, copied) {
    const idle = button.querySelector('.product-discount-code__copy-icon--idle');
    const done = button.querySelector('.product-discount-code__copy-icon--done');
    button.classList.toggle('is-copied', copied);
    if (idle) idle.hidden = copied;
    if (done) done.hidden = !copied;
    button.setAttribute('aria-label', copied ? 'Discount code copied' : `Copy discount code ${button.dataset.discountCode || ''}`);
  }

  function bindButton(button) {
    if (button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';

    button.addEventListener('click', async () => {
      const code = button.dataset.discountCode || '';
      const ok = await copyText(code);
      if (!ok) return;

      setCopiedState(button, true);
      window.clearTimeout(button._copyResetTimer);
      button._copyResetTimer = window.setTimeout(() => {
        setCopiedState(button, false);
      }, RESET_MS);
    });
  }

  function init(root = document) {
    root.querySelectorAll('[data-product-discount-code] .product-discount-code__copy').forEach(bindButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
